'use client'

import { useState } from 'react'

import { useLivePreview } from '@payloadcms/live-preview-react'

import type { CmsSellerProfile } from '@/helpers/api/fetchPayload'

/**
 * Depth of the server-side profile fetch (`fetchSellerProfile`). Payload's live merge re-populates
 * relationships to this depth, so the pane's data has the same shape as the initial render.
 */
const LIVE_PREVIEW_DEPTH = 3

/** The profile as the admin form currently has it, starting from the server-rendered one. */
export function useSellerProfileLivePreview(
  profile: CmsSellerProfile,
  /** Origin of the admin that opened the pane, read on mount only; cms-portal serves its API under its basePath, hence `apiRoute`. */
  serverURL: string
): CmsSellerProfile {
  // Paired once, with the admin that opened the pane. A tab click re-renders the page on the
  // server with the pane itself as the referrer, which would re-pair it with its own origin and
  // drop every later edit from the admin.
  const [pairedServerURL] = useState(serverURL)
  const { data } = useLivePreview<CmsSellerProfile>({
    initialData: profile,
    serverURL: pairedServerURL,
    apiRoute: '/cms-portal/api',
    depth: LIVE_PREVIEW_DEPTH,
  })
  return data
}
